<template>
  <div id="post-filter-is-moderate-select">
    <label class="form-label">Модерация</label>
    <Multiselect @change="onChange" v-model="fields.is_moderate_id" mode="single" placeholder="Выбрать" noResultsText="Результатов не найдено" :searchable="true" :close-on-select="true" :options="getValues()" :trackBy="'title'" :max="1">
      <template v-slot:singlelabel="{ value }">
        <div class="multiselect-single-label option-item">
          <div class="item-name">{{ value.title }}</div>
        </div>
        </template>
        <template v-slot:option="{ option }">
        <div class="option-item">
          <div class="item-name">{{ option.title }}</div>
        </div>
      </template>
    </Multiselect>
  </div>
</template>

<script>
import "./css/style.css"
import {defineComponent, watch, ref, onMounted, reactive} from "vue"
import Multiselect from "@/plugins/multiselect"

export default defineComponent({
  name: "IsModerate",
  components: {
    Multiselect,
  },
  props: {
    data: {
      type: [Object, null],
      default: null,
    },
  },
  setup(props, {emit}) {
    let isModerateValues = ref([])

    const fields = reactive({
      is_moderate_id: props.data.val,
    })

    onMounted(async () => {
      fields.is_moderate_id = props.data.val;

      let isModerates = [
        {
          id: null,
          title: "Не выбрано",
        },
        {
          id: 1,
          title: "Промодерировано",
        },
        {
          id: 0,
          title: "Не промодерировано",
        },
      ]

      setValues(isModerates);
    })

    watch(() => props.data.val, (val) => {
      fields.is_moderate_id = val
    })

    watch(() => props.data.isModerates, (val) => {
      setValues(val);
    })

    function setValues(items) {
      let filtered = []
      for (let prop in items) {
        let obj = items[prop]

        filtered.push({
          value: obj["id"],
          title: obj["title"],
        })
      }

      isModerateValues.value = filtered
    }

    function getValues() {
      return isModerateValues.value;
    }

    function onChange(value) {
      fields.is_moderate_id = value
      emit("onChange", fields.is_moderate_id)
    }

    return {
      onChange,
      getValues,
      fields,
    }
  }
})
</script>
